import DashboardChartContainer from "./DashboardChartContainer";

export default DashboardChartContainer;
